<template>
<div>
    <div class="mcc-page-header mu-d-flex">
        <div class="mu-d-flex mu-w-100 mu-justify-content-between">
            <section class="mu-d-flex">
                <h1 class="mu-mb-00">User details</h1>
                <details class="mcc-popover mcc-popover--bottom-end" @click="showHelpText = !showHelpText">
                    <summary class="mu-mt-03 mu-ml-02 ">
                        <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                    </summary>
                    <div class="mcc-popover__content">
                        <p class="mu-mb-00">
                            {{ helpText.title }}
                            <a :href="helpText.url" target="_blank">Read more...</a>
                        </p>
                    </div>
                </details>
            </section>
            <section>
                <div class="mu-d-flex mu-justify-content-end d-flex justify-content-end" spaced="">
                    <button class="mcc-button mcc-button--success" id="saveBtn" title="Save" v-if="userDto.deleted == null" @click="saveUser">
                        <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                    </button>
                </div>
            </section>
        </div>
    </div>
    <div class="mcc-container card-padding">
        <nav aria-label="breadcrumb" class="">
            <ol class="mcc-breadcrumb">
                <li>User profile</li>
            </ol>
        </nav>
        <div class="mcc-row" v-if="!fetchCall">
            <div class="mcc-col colSpinner">
                <div class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>

            </div>

        </div>
    
       
        <div class="mcc-row" v-show="fetchCall">
            <div class="mcc-col">
                <div class="mcc-card">
                    <div class="mcc-row mu-m-06"  v-show="userDto.deleted != null" >
                        <div class="mcc-col">
                            <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" color="warning">
                                <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                                <p>
                                    <strong>Warning!</strong>
                                    <br />This user has been disabled and cannot be changed.
                                    <br />
                                    Reason: {{userDto.deletedReason}}
                                </p>
                            </mcc-alert>
                        </div>
                    </div>
                    <form @submit.prevent="saveUser()" id="saveUser" novalidate>
                        <div class="mcc-row">
                            <div class="mcc-col">
                                <div class="mcc-tabs mcc-tabs--bar mcc-tabs--vertical mcc-tabs--contained" style="min-height: 550px;">
                                    <input type="radio" id="profile" name="as-default-tab-control" checked="">
                                    <input type="radio" id="properties" name="as-default-tab-control">
                                    <input type="radio" id="groups" name="as-default-tab-control">
                                    <input type="radio" id="externalSystemUserMappings" name="as-default-tab-control">
                                    <ul role="tablist">
                                        <li role="tab">
                                            <label for="profile" tabindex="0">
                                                <span>Profile</span>
                                            </label>
                                        </li>
                                        <li role="tab">
                                            <label for="properties" tabindex="0">
                                                <span>Properties</span>
                                            </label>
                                        </li>
                                        <li role="tab">
                                            <label for="groups" tabindex="0">
                                                <span>Groups</span>
                                            </label>
                                        </li>
                                        <li role="tab">
                                            <label for="externalSystemUserMappings" tabindex="0">
                                                <span>External system user mappings</span>
                                            </label>
                                        </li>
                                    </ul>
                                    <div role="tabpanel" class="mu-m-06 mu-w-100">
                                        <h5 class="mu-fs-4 mu-fw-semi-bold">
                                            Profile
                                        </h5>
                                        <div>
                                            <div class="mcc-row">
                                                <div class="mcc-col">
                                                    <div class="mfc-input-wrapper mfc-form-input-wrapper--width mu-d-block mfc-form-input-container mu-mb-05">
                                                        <label for="firstName">First name</label>
                                                        <input type="text" name="firstName" id="firstName" disabled="" placeholder="First name" :value="userDto.firstName">
                                                    </div>
                                                    <div class="mfc-input-wrapper mfc-form-input-wrapper--width mu-d-block mfc-form-input-container mu-mb-05">
                                                        <label for="surname">Surname</label>
                                                        <input type="text" name="surname" id="surname" disabled="" placeholder="Surname" :value="userDto.surname">
                                                    </div>
                                                    <div class="mfc-input-wrapper mfc-form-input-wrapper--width mu-mb-05">
                                                        <label for="mds_input_group_buttons">Email</label>
                                                        <div class="mfc-input-group">
                                                            <input id="mds_input_group_buttons" name="mds_input_group_buttons" type="text" :value="userDto.email" disabled>
                                                            <button type="button" class="mcc-button mcc-button--soft-secondary" @click="openMailTo(userDto.email)">Send</button>
                                                        </div>

                                                    </div>
                                                    <!-- <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-05" :value="userDto.surname">
                                                        <label class="font-weight-bold d-block">Email</label>
                                                            <a :href="`mailto:${userDto.email}`">{{userDto.email}}</a>
                                                        </div> -->
                                                    <div class="mfc-slim-select-wrapper mfc-form-input-wrapper--width mu-mb-05 mu-d-none" >
                                                        <label for="themeId" class="mu-mb-00">Select theme</label>
                                                        <select ref="themeRef" id="themeId" @change="changeTheme($event)" name="themeCode" block label="Select theme">
                                                            <option value="" :selected="selectedTheme==null || selectedTheme==''">Admin Selected</option>
                                                            <option value="theme-default" :selected="selectedTheme=='theme-default'">Default</option>
                                                            <option :selected="selectedTheme==theme.code" v-for="(theme,key) in userDefinedThemes" :key="key" :value="theme.code">{{theme.name}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="flatpickr flatpickrGap mfc-input-wrapper mfc-form-input-wrapper--width" ref="outOfficeDate">
                                                        <label for="inputGroupDefault1" class="mu-mb-00">Out of office between<small> - Optional</small></label>
                                                        <div class="mfc-input-group flatpickr-date--width mfc-input-group--has-help-text flatPickrDiv mfc-input-group--has-validation-text" id="UpdatedateSelect" >
                                                            <input type="text" placeholder="Select Date.." data-input ref="updatedDateInput" name="outOfficeDate" id="updatedDateId" prepend icon="calendar" @change="handleOutOfficeRangeChange($event)" @ready="handleOutOfficeRangeReady()" :disabled="userDto.deleted != null">
                                                            <button type="button" class="mcc-button mcc-button--soft-secondary mcc-button--icon-only" data-toggle>
                                                                <mcc-icon aria-hidden="true" name="calendar"></mcc-icon>
                                                            </button>
                                                            
                                                        </div>
                                                    </div>
                                                    <div class="mfc-checkbox-wrapper mfc-form-input-container" id="sendEmailNotification" color="primary">
                                                        <input type="checkbox" id="sendEmail" class="mfc-switch" ref="sendEmailNotification" :disabled="userDto.deleted != null" name="sendEmailNotification" :checked="userDto.sendEmailNotification" @change="userDto.sendEmailNotification = $event.target.checked">
                                                        <label for="sendEmail">Send email notification</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div role="tabpanel" class="mu-m-06 mu-w-100">
                                        <h5 class="mu-fs-4 mu-fw-semi-bold">
                                            Properties
                                        </h5>
                                        <div>
                                            <div v-for="(property,index) in userDto.properties" :key="index">
                                                <div class="mcc-row" v-if="property.definition.type == 'FREE_TEXT'">
                                                    <div class="mcc-col">
                                                        <div class="mcc-row">
                                                            <div class="mcc-col">
                                                                <label class="font-weight-bold mt-2">{{property.definition.label}}</label>
                                                                <small v-if="!property.definition.mandatory">
                                                                    - Optional</small>
                                                            </div>
                                                        </div>
                                                        <div class="mcc-row">
                                                                <div class="mcc-col">
                                                                <div class="mfc-input-wrapper  mu-d-block mfc-form-input-container mu-mb-05">
                                                                    <label :for="'properties['+index+'].value'" :class="{'mfc-label--required': property.definition.mandatory}">Value</label>
                                                                    <input type="text" maxlength="50" :disabled="userDto.deleted != null || property.definition.readOnly && !isAdminUser" :id="'properties['+index+'].value'" :name="'properties['+index+'].value'" :value="userDto.properties[index].value" @change="userDto.properties[index].value = $event.target.value" :required="property.definition.mandatory">
                                                                </div>
                                                                </div>
                                                                <div class="mcc-col">
                                                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-05">
                                                                    <label :for="'properties['+index+'].description'" :class="{'mfc-label--required': property.definition.mandatory}">Description</label>
                                                                    <input type="text" maxlength="100" :disabled="userDto.deleted != null || property.definition.readOnly && !isAdminUser" :id="'properties['+index+'].description'" :name="'properties['+index+'].description'" :value="userDto.properties[index].description" @change="userDto.properties[index].description = $event.target.value" :required="property.definition.mandatory">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="mcc-row" v-if="property.definition.type == 'SELECTION'">
                                                    <div class="mcc-col ">
                                                        <div class="mfc-slim-select-wrapper mu-mb-05 mfc-form-input-wrapper--width  mu-pr-04 "  v-if="!property.definition.mandatory" >
                                                            <label for="groups" class="mu-mb-00">{{property.definition.label}}</label>
                                                            <select class="slimSelectClass" :id="'properties['+index+'].value'" :name="'properties['+index+'].value'" @change="userDto.properties[index].value = $event.target.value" :disabled="userDto.deleted != null || property.definition.readOnly && !isAdminUser" block optional :label="property.definition.label">
                                                                <option value=" " :selected="userDto.properties[index].value ==' '"></option>
                                                                <option v-for="(option,key) in property.definition.options" :key="key" :selected="userDto.properties[index].value == option.value" :value="option.value">{{option.value}} - {{option.description}}</option>
                                                            </select>
                                                        </div>
                                                        
                                                        <div class="mfc-slim-select-wrapper mu-mb-05 mfc-form-input-wrapper--width  mu-pr-04 " v-if="property.definition.mandatory">
                                                            <label for="groups" class="mu-mb-00">{{property.definition.label}}</label>
                                                            <select class="slimSelectClass" :id="'properties['+index+'].value'" :name="'properties['+index+'].value'" @change="userDto.properties[index].value = $event.target.value" :disabled="userDto.deleted != null" block  required :label="property.definition.label">
                                                                <option v-for="(option,key) in property.definition.options" :key="key" :selected="userDto.properties[index].value == option.value" :value="option.value">{{option.value}} - {{option.description}}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div role="tabpanel" class="mu-m-06 mu-w-100">
                                        <h5 class="mu-fs-4 mu-fw-semi-bold">
                                            Groups
                                        </h5>
                                        <div>
                                            <div class="mcc-row">
                                                <div>
                                                    <span class="mcc-chip mcc-chip--xs mcc-chip--soft-info mu-mr-04 mu-mb-04" v-for="(ele,index) in selectedGroupsName" :key="index">{{ele}}</span>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div role="tabpanel" class="mu-m-06 mu-w-100">
                                        <h5 class="mu-fs-4 mu-fw-semi-bold">
                                            External user system mappings
                                        </h5>
                                        <div class="mcc-row">
                                            <div class="mcc-col">
                                                <div class="mfc-slim-select-wrapper mu-mb-05 mfc-form-input-wrapper--width">
                                                    <label for="externalSystems" class="mu-mb-00">External system</label>
                                                    <select :disabled="userDto.deleted != null" v-if="userMappingAvailable" @change="handleExternalSysChange($event.target.value)" id="externalSystems" ref="externalSystems" name="externalSystems" block label="External system">
                                                        <option :value="ele.externalSystem.name" v-for="(ele,index) in systemUserDetailList" :key="index" :selected="index == 0">{{ele.externalSystem.name}}</option>
                                                    </select>
                                                </div>
                                                <div class="mcc-row" v-if="userMappingAvailable && showUserMappingFields">
                                                    <div class="mcc-col">
                                                        <div class="mfc-textarea-wrapper marginTop0 mfc-form-input-container mfc-form-input-wrapper--width mu-mb-03" ref="extSysDesc" placeholder="Description">
                                                            <label for="extSysDesc">Description</label>
                                                            <textarea id="extSysDesc" name="extSysDesc" readonly="" :value="selExtSys.externalSystem.description"></textarea>
                                                            <div class="mfc-invalid-feedback"></div>

                                                        </div>
                                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mfc-form-input-wrapper--width mu-mb-05">
                                                            <label for="userNameAlias">User name alias</label>
                                                            <input type="text" readonly="" id="userNameAlias" name="userNameAlias" maxlength="50" :value="selExtSys.username" @change="selExtSys.username = $event.target.value">

                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </form>
                </div>

            </div>

    
    </div></div>
</div>
</template>

<script>
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import UserAPI from '../../../services/UserAPI';
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages
} from '../../../formvalid.js';
import {
    mapState
} from "vuex";
export default {
    name: "UserProfile",
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["user.profile"],
            userDto: {},
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            deletedReason: "",
            fetchCall: false,
            showHelpText: false,
            selectedGroupsName: [],
            userMappingAvailable: true,
            systemUserDetailList: [],
            selExtSys: {},
            showUserMappingFields: false,
            outOfOfficeRef: [],
            isAdminUser: false,
            selectedTheme: '',
            originalTheme: '',
            selectInstanceEntities: [],
            createdDateFlatPickrInstance: null,
        };
    },
    updated() {
        this.flatpickr()
    },
    computed: {
        ...mapState(['userDefinedThemes'])

    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        this.getUserProfileDetails();
        EventBus.$on("exitPreviewMode", () => {
            this.selectedTheme = this.originalTheme
            this.$refs.themeRef.value = this.selectedTheme
        })
        this.selectInstanceEntities = new SlimSelect({
            select: '#themeId',
        })
        this.selectInstanceEntities = new SlimSelect({
            select: '#externalSystems',
        })
    },
    beforeDestroy() {
        EventBus.$off("exitPreviewMode");
    },
    methods: {
        initSlimSelect(selector) {
            if (!document.querySelector(selector)._slim) {
                new SlimSelect({
                    select: selector
                });
            }
        },
        initSlimSelectForClass(className) {
            document.querySelectorAll(className).forEach((element) => {
                if (!element._slim) {
                    new SlimSelect({
                        select: element
                    });
                }
            });
        },
        openMailTo(email) {
            let mailTo = "mailto:" + email + ""
            window.location = mailTo;
        },
        changeTheme(e) {
            this.selectedTheme = e.target.value
            this.userDto.themeCode = this.selectedTheme
            if (this.selectedTheme == '') {
                this.selectedTheme = this.$store.getters.getThemeData.themeCode
            }

            if (this.selectedTheme != 'theme-default') {
                const themeDTO = this.$store.getters.getThemeFromCode(this.selectedTheme)
                const theme = document.querySelector('mosaic-user-defined-theme')
                const variables = JSON.parse(themeDTO.variables)
                theme.theme = variables;
                //theme.generateCss(variables['navbar-bg-lg'])
                theme.preview()
            } else {
                const theme = document.querySelector('mosaic-user-defined-theme')
                // theme.generateCss('#242424')
                if (theme) {
                    theme.preview()
                }
            }
            this.selectedTheme = this.userDto.themeCode
            this.$store.dispatch('updatePreviewMode', true)

        },
        getUserProfileDetails() {
            let self = this;
            self.selectedGroupsName = [];
            self.systemUserDetailList = [];
            self.fetchCall = false;
            UserAPI.getUserProfileDetails()
                .then(result => {
                    if (result == null) {
                        self.redirectToList();
                        EventBus.$emit('error-notification', {
                            "msg": "Error while fetching user"
                        });
                        return;
                    }
                    self.dataLoaded = true;
                    self.userDto = result.user;
                    if (self.userDto) {

                        self.selectedTheme = self.userDto.themeCode
                        self.originalTheme = self.selectedTheme
                        //self.$refs.themeRef.value = self.selectedTheme
                    }
                    if (self.userDto.outOfOfficeStartDate != null && self.userDto.outOfOfficeEndDate != null) {
                        self.outOfOfficeRef[0] = new Date(self.userDto.outOfOfficeStartDate);
                        self.outOfOfficeRef[1] = new Date(self.userDto.outOfOfficeEndDate);
                    }
                    this.createdDateFlatPickrInstance.setDate([self.outOfOfficeRef[0], self.outOfOfficeRef[1]]);
                    self.userMappingAvailable = result.userMappingAvailable;
                    self.isAdminUser = result.isAdminUser;
                    self.userDto.groups.forEach(function (selGrp, index) {
                        self.selectedGroupsName.push(selGrp.name);
                    });
                    self.userDto.systemUserDetails.forEach(function (sysUserDetail, index) {
                        if (sysUserDetail.externalSystem.requiresUserMapping) {
                            self.systemUserDetailList.push(sysUserDetail);
                        }
                    });
                    if (self.systemUserDetailList.length > 0) {
                        self.selExtSys = self.systemUserDetailList[0];
                        self.showUserMappingFields = true;
                    }
                    let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.user.details"] + " - " + self.userDto.username;
                    EventBus.$emit("update-pageTitle", pageTitle);
                })
                .finally(() => {
                    if (self.dataLoaded) {
                        self.fetchCall = true;
                    }
                    self.initSlimSelect('#themeId');
                    self.initSlimSelectForClass('.slimSelectClass');
                });
        },
        handleExternalSysChange(selectedExtSysName) {
            this.showUserMappingFields = false;
            this.selExtSys = this.systemUserDetailList.find(obj => obj.externalSystem.name == selectedExtSysName);
            this.updateShowUserMappingFields();
        },
        async updateShowUserMappingFields() {
            await this.$nextTick();
            this.showUserMappingFields = true;
        },
        handleOutOfficeRangeChange(e) {
            this.outOfOfficeRef = [];
            if (this.createdDateFlatPickrInstance.selectedDates.length > 1) {
                this.outOfOfficeRef = this.createdDateFlatPickrInstance.selectedDates;
            }
        },
        handleOutOfficeRangeReady() {
            this.$refs.outOfficeDate.value = this.outOfOfficeRef;
        },
        flatpickr() {
            let self = this;

            self.createdDateFlatPickrInstance = flatpickr('.flatPickrDiv', {
                dateFormat: 'd/M/Y',
                altInput: true,
                wrap: true,
                altFormat: 'd/m/Y',
                mode: 'range',
            });
        },
        saveUser() {
            let form = $('#saveUser')

            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            let self = this;
            if (self.outOfOfficeRef.length > 0) {
                let outOfOfficeStartDate = self.outOfOfficeRef[0];
                let outOfOfficeEndDate = self.outOfOfficeRef[1];
                this.userDto.outOfOfficeStartDate = moment(outOfOfficeStartDate).format('YYYY-MM-DD');
                this.userDto.outOfOfficeEndDate = moment(outOfOfficeEndDate).format('YYYY-MM-DD');
            }
            UserAPI.saveUserProfile(self.userDto).then(response => {
                if (response.error) {
                    EventBus.$emit("error-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                } else {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    self.getUserProfileDetails();
                    this.$store.dispatch('updatePreviewMode', false)
                }
            });
        },
    }
};
</script>

<style scoped>
.marginTop0 {
    margin-top: 0 !important;
}

.mu-width-70 {
    width: 70%;
}

.mfc-form-input-wrapper--width {
    width: 300px;
}
</style>
